<i18n>
{
    "en-BE":{
        "tab_title": "Input Form",
        "ing": {
            "tab_title": "ING Input Form"
        }
    },
    "fr-BE":{
        "tab_title": "Formulaire",
        "ing": {
            "tab_title": "Formulaire ING"
        }
    },
    "nl-BE":{
        "tab_title": "Input Form",
        "ing": {
            "tab_title": "ING Input Form"
        }
    }
}
</i18n>

<template>
    <div id="valuation">
        <div class="columns is-centered">
            <div
                class="column pb-0 pr-0"
                :class="[
                    $route.params.action == 'faq'
                        ? 'is-3 is-2-desktop '
                        : 'is-4 is-3-desktop ',
                ]"
            >
                <app-side-steps />
            </div>
            <div
                class="column pl-0"
                :class="[
                    $route.params.action == 'faq'
                        ? 'is-10-desktop is-9'
                        : 'is-9-desktop is-8',
                    { skiline: $route.params.action === 'start' },
                ]"
            >
                <app-start v-if="$route.params.action == 'start'" />
                <app-enter
                    v-if="$route.params.action == 'enter' && flow_type !== 'avm_demo'"
                />
                <app-building-type v-if="$route.params.action == 'building-type'" />
                <app-address
                    v-if="$route.params.action == 'address'"
                    :building-type="buildingType"
                />
                <app-map-select
                    v-if="
                        [
                            'confirm-main-building',
                            'select-main-building',
                            'select-secondary-buildings',
                            'select-parcels',
                            'confirm-main-parcel',
                            'select-main-parcel',
                            'select-extra-parcels',
                            'view-building-parcels',
                        ].includes($route.params.action)
                    "
                />
                <app-extra-info
                    v-if="$route.params.action == 'extra-info'"
                    ref="extra-info"
                    :building-type="buildingType"
                />
                <app-renovation-info v-if="$route.params.action == 'renovation-info'" />
                <app-feed-back v-if="$route.params.action == 'feedback'" />
                <app-info v-if="getRouteForInfo" />

                <app-faq v-if="$route.params.action == 'faq'" />
            </div>
        </div>
    </div>
</template>

<script>
import AppStart from './request/01-Start.vue'
import AppEnter from './request/02-Enter.vue'
import AppBuildingType from './request/03-BuildingType.vue'
import AppAddress from './request/04-address'
import AppMapSelect from './request/04.1-MapSelect'
import AppExtraInfo from './request/05.0-ExtraInfo.vue'
import AppRenovationInfo from './request/05.4-RenovationQuotation.vue'
import AppFeedBack from './request/06-FeedBack'
import AppSideSteps from './request/SideSteps'
import AppInfo from '@/shared/components/Info.vue'
import AppFaq from '@/shared/components/FAQ.vue'

import { mapActions, mapGetters, mapMutations } from 'vuex'
import { localeMixin } from '@/components/mixins/locale.js'
import utils from '@/shared/plugins/utils'

export default {
    name: 'ValuationRequest',
    components: {
        AppStart,
        AppEnter,
        AppAddress,
        AppMapSelect,
        AppSideSteps,
        AppExtraInfo,
        AppRenovationInfo,
        AppFeedBack,
        AppBuildingType,
        AppInfo,
        AppFaq,
    },
    mixins: [localeMixin],
    beforeRouteEnter(to, from, next) {
        if (to.params.action === 'start') {
            next((vm) => {
                vm.RESET_FULL_DATA()
                vm.RESET_VAL()
                vm.SET_CUSTOMER_REF(null)
            })
        } else {
            next()
        }
    },
    beforeRouteLeave(to, from, next) {
        if (from.params.action === 'extra-info') {
            this.$refs['extra-info'].onLeaving(next)
        } else {
            this.onRouteUpdate(to, from)
            next()
        }
    },
    computed: {
        ...mapGetters(['flow_type']),
        ...mapGetters('valuationStore', ['getFullValuationStore']),
        getRouteForInfo() {
            return (
                this.$route.params.action !== 'faq' &&
                this.$config.LOCALE_OVERWRITE === 'ing'
            )
        },
        tabTitle() {
            return this.t('tab_title')
        },
        buildingType() {
            return this.$store.state.valuationStore.Address.features.f_building_type
        },
    },
    watch: {
        // updete BE store with local data and then get updated data from BE on route change
        $route(to, from) {
            this.onRouteUpdate(to, from)
        },
    },
    created() {
        this.$i18n.locale = this.$route.params.lang
        // Already loaded in router, if loaded here can cause race condition!
        //if (this.$route.params.action !== 'start') this.load_valuation_request()
    },
    methods: {
        ...mapActions('valuationStore/Address', ['fetch_features']),
        ...mapActions('valuationStore', ['load_valuation_request']),
        ...mapMutations('valuationStore', [
            'UPDATE_STATUS',
            'RESET_VAL',
            'SET_CUSTOMER_REF',
        ]),
        ...mapMutations('valuationStore/Address', ['RESET_FULL_DATA']),
        onRouteUpdate(to, from) {
            if (to.params.action === 'start') {
                this.RESET_FULL_DATA()
                this.RESET_VAL()
                this.SET_CUSTOMER_REF(null)
            } else if (to.params.action === 'enter') {
            } else {
            }
        },
    },
    metaInfo() {
        return {
            // if no subcomponents specify a metaInfo.title, this title will be used
            title: this.tabTitle,
            // all titles will be injected into this template
            titleTemplate: '%s | Rock.estate Valuation App',
        }
    },
}
</script>

<style src="@/assets/style/index.scss" lang="scss"></style>

<style lang="scss" scoped>
.skiline {
    background: url('../../../assets/icons/img-skyline.svg') no-repeat bottom right;
    background-size: contain;
}
</style>
